export default __webpack_public_path__ + "static/media/background-login.00eeac95.png";